/* Reel-for-refund dialog (snippets/runit-reel-refund.liquid). Native <dialog>.showModal() gives the
   focus trap, inert page and Escape; this adds open, close-button/backdrop close, scroll lock and
   focus return. Click is delegated so it survives the product section being re-rendered. */
(function () {
  var opener = null;
  var returnKeyboardFocus = false;
  // Restore visible focus for keyboard use; mouse/touch dismissal should not
  // leave the trigger looking selected after the native dialog restores focus.
  document.addEventListener('keydown', function () {
    if (opener) returnKeyboardFocus = true;
  });
  document.addEventListener('pointerdown', function () {
    if (opener) returnKeyboardFocus = false;
  });

  document.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest('[data-rl-reel-open]');
    if (!btn) return;
    var dlg = document.getElementById(btn.getAttribute('aria-controls'));
    if (!dlg || dlg.open || typeof dlg.showModal !== 'function') return;
    opener = btn;
    returnKeyboardFocus = e.detail === 0;
    dlg.showModal();
    document.body.classList.add('runit-dialog-open');
    if (window.RunItAnalytics) window.RunItAnalytics.capture('reel_refund_opened', {});
  });

  document.addEventListener('click', function (e) {
    var dlg = e.target.closest && e.target.closest('dialog.rl-reel__dialog');
    // The dialog has no padding of its own, so a click whose target is the dialog is the backdrop.
    if (dlg && (e.target === dlg || e.target.closest('[data-rl-reel-close]'))) dlg.close();
  });

  document.addEventListener('close', function (e) {
    if (!e.target.matches || !e.target.matches('dialog.rl-reel__dialog')) return;
    document.body.classList.remove('runit-dialog-open');
    if (opener && opener.isConnected) {
      if (returnKeyboardFocus) opener.focus({ preventScroll: true }); else opener.blur();
    }
    opener = null;
  }, true);
})();
